import { useState, useEffect, useContext } from 'react';
import CompanyService from 'services/company2';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import * as React from 'react';
function IfbPriceCompare(props) {
  const {
    prodList,
    handleDrawer,
    decimalPlace,
    companyCode,
    quoteTemplateDetailList,
    quoteCustomFieldList,
    templateUniqueCode
  } = props;

  return (
    <div className="order-detail-list price-compare-list">
      {!templateUniqueCode && (
        <ul>
          {prodList &&
            prodList &&
            prodList.map((item, index) => (
              <li
                className={
                  item.activeFlag
                    ? 'order-detail-item active'
                    : 'order-detail-item'
                }
                key={String(item.id) + index}
              >
                <div
                  className="prod"
                  onClick={() => {
                    handleDrawer(item);
                  }}
                >
                  {item.productCode}，{item.productName}，{item.productScale}
                  <i className="icon-down"></i>
                </div>
                <div className="price">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <span className="green">
                            最低价：
                            {formatNumber(
                              item.minPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </span>
                        </td>
                        <td>
                          <span>
                            平均值：
                            {formatNumber(
                              item.avgPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </span>
                        </td>
                        <td>
                          <span className="red">
                            最高价：
                            {formatNumber(
                              item.maxPrice,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {item.activeFlag && (
                  <div className="quoProductsBox">
                    {item.prodDetails &&
                      item.prodDetails.map((line, idx) => (
                        <ul className="quoProductsList clearfix" key={idx}>
                          <li className="single">
                            <p className="f14">
                              {line.innerVendorName} {line.innerVendorCode}
                            </p>
                          </li>
                          <li className="single">
                            {
                              <div className="quotes">
                                <span>
                                  报价数量：
                                  {formatNumber(
                                    line.quantity,
                                    decimalPlace.Quantity_Decimal_Place
                                  )}
                                </span>
                                <span>
                                  单价：
                                  {formatNumber(
                                    line.quotePrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                  {line.quoteCurrencyName || '--'}
                                </span>
                              </div>
                            }
                          </li>
                          <li>
                            含税否/税率：
                            {line.priceContainTaxFlagShow}
                            {line.taxRateShow ? line.taxRateShow + '%' : ''}
                          </li>
                        </ul>
                      ))}
                  </div>
                )}
              </li>
            ))}
        </ul>
      )}
      {templateUniqueCode && (
        <ul>
          {quoteTemplateDetailList &&
            quoteTemplateDetailList &&
            quoteTemplateDetailList.map((item, index) => (
              <li
                className={
                  item.activeFlag
                    ? 'order-detail-item active'
                    : 'order-detail-item'
                }
                key={String(item.id) + index}
              >
                <div
                  className="prod"
                  onClick={() => {
                    handleDrawer(item);
                  }}
                >
                  <span>序号：{item.sortNo}</span>&nbsp;
                  <span>报价项目：{item.itemName}</span>&nbsp;
                  <span>报价规格：{item.itemScale}</span>&nbsp;
                  <i className="icon-down"></i>
                </div>
                {item.activeFlag && (
                  <div className="quoProductsBox">
                    {item.vendorDetails &&
                      item.vendorDetails.map((line, idx) => (
                        <ul className="quoProductsList clearfix" key={idx}>
                          <li className="single">
                            <p className="f14">
                              {line.innerVendorName} {line.innerVendorCode}
                            </p>
                          </li>
                          <li className="single">
                            {
                              <div className="quotes">
                                <span>
                                  数量：
                                  {formatNumber(
                                    line.purchaseQty,
                                    decimalPlace.Quantity_Decimal_Place
                                  )}
                                </span>
                                <span>单位：{line.unitName}</span>
                              </div>
                            }
                          </li>
                          <li>
                            独立设备：
                            {line.isIndependentEquipment === 1 ? '是' : '否'}
                          </li>
                          <li>
                            报价币别：
                            {line.quoteCurrencyName}
                          </li>
                          <li>
                            含税否/税率：
                            {line.priceContainTaxFlagShow}
                            {line.taxRateShow ? line.taxRateShow + '%' : ''}
                          </li>
                          <li>
                            含税金额：
                            {formatNumber(
                              line.taxAmount,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </li>
                          <li>
                            未税金额：
                            {formatNumber(
                              line.unTaxAmount,
                              decimalPlace.Price_Decimal_Place
                            )}
                          </li>
                          {quoteCustomFieldList &&
                            quoteCustomFieldList
                              .filter(field => field.type === 1)
                              .map((field, i) => (
                                <li key={i}>
                                  {field.customName}：
                                  {formatNumber(
                                    line.vendorCustomFields.filter(
                                      value => value.type === 1
                                    )[i].price,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                              ))}
                          {quoteCustomFieldList &&
                            quoteCustomFieldList
                              .filter(field => field.type === 2)
                              .map((field, i) => (
                                <li key={i}>
                                  {field.customName}：
                                  {formatNumber(
                                    line.vendorCustomFields.filter(
                                      value => value.type === 2
                                    )[i].description,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                              ))}
                        </ul>
                      ))}
                  </div>
                )}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}
export default IfbPriceCompare;
